import React, { Component, PropTypes } from 'react';
import { Filter, VirtualTable, Pagination } from 'containers';
import { InspectionFilter, InspectionScriptPopup } from 'components';
import _ from 'lodash';
import * as util from 'lib/utility';
import debug from 'debug';
import translate from 'i18n/translate';
import { Tabs, Tab } from 'react-toolbox/lib/tabs';
import Modal from 'react-modal';
import ProgressBar from 'react-toolbox/lib/progress_bar';
import styles from './FixedTabs.css';

let warmLeadsCount = '';
class FixedTabs extends Component {
  static defaultProps = {
    options: [],
    selectedRecords: []
  }
  static propTypes = {
    columnData: PropTypes.arrayOf(PropTypes.shape({})),
    inspectionsColumnData: PropTypes.arrayOf(PropTypes.shape({})),
    strings: React.PropTypes.shape({}),
    updateSelectedRecords: PropTypes.func,
    updateProgressBarValue: PropTypes.func,
    selectedRecords: React.PropTypes.arrayOf(PropTypes.shape({})),
    tabOneSearchedLeads: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    tabOneList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    tabTwoList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    tabThreeList: PropTypes.arrayOf(PropTypes.shape({})),
    tabActiveLeadsList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    leadsData: PropTypes.arrayOf(PropTypes.shape({})),
    unassignedStartIndex: PropTypes.number,
    unassignedEndIndex: PropTypes.number,
    assignedStartIndex: PropTypes.number,
    assignedEndIndex: PropTypes.number,
    updateUnassignedStartEndIndex: PropTypes.func,
    updateAssignedStartEndIndex: PropTypes.func,
    activeIndex: PropTypes.number,
    updateActiveIndex: PropTypes.func,
    updateFilterExpanded: PropTypes.func,
    updateInspectionFilterExpanded: PropTypes.func,
    filterExpanded: PropTypes.bool,
    inspectionFilterExpanded: PropTypes.bool,
    filterData: PropTypes.arrayOf(PropTypes.shape({})),
    inspectionFilterData: PropTypes.arrayOf(PropTypes.shape({})),
    updateFilter: PropTypes.func,
    applyFilter: PropTypes.func,
    applyFilterIndex: PropTypes.func,
    filterValues: PropTypes.shape({}),
    clearFilter: PropTypes.func,
    clearFilterIndex: PropTypes.func,
    dataIsLoading: PropTypes.bool,
    applySearchName: PropTypes.func,
    applySearchStreet: PropTypes.func,
    applySearchWritingAgent: PropTypes.func,
    applySearchPhone: PropTypes.func,
    tabOneSearchList: PropTypes.arrayOf(PropTypes.shape({})),
    tabTwoSearchList: PropTypes.arrayOf(PropTypes.shape({})),
    tabThreeSearchList: PropTypes.arrayOf(PropTypes.shape({})),
    tabActiveSearchList: PropTypes.arrayOf(PropTypes.shape({})),
    priAndSecRecordMapping: PropTypes.shape({}),
    progressBar: PropTypes.shape({}),
    searchValueNameTabOne: PropTypes.string,
    searchValueNamePriorityTab: PropTypes.string,
    searchStreetAddressPriorityTab: PropTypes.string,
    searchPhonePriorityTab: PropTypes.string,
    searchStreetAddressTabOne: PropTypes.string,
    searchValueNameTabTwo: PropTypes.string,
    searchStreetAddressTabTwo: PropTypes.string,
    searchWritingAgentTabThree: PropTypes.string,
    searchValueNameTabThree: PropTypes.string,
    updateNameSearchParameter: PropTypes.func,
    updateStreetSearchParameter: PropTypes.func,
    inspectedFilterValues: PropTypes.shape({}),
    agentList: PropTypes.shape({}),
    updateWritingAgentParameter: PropTypes.func,
    inspectedStartIndex: PropTypes.number,
    inspectedEndIndex: PropTypes.number,
    currentLanguage: React.PropTypes.string,
    updateInspectedStartEndIndex: React.PropTypes.func,
    loginUserRecord: PropTypes.shape({}),
    updateActivePage: React.PropTypes.func,
    activePage: PropTypes.bool,
    updatePhoneParameter: PropTypes.func,
    searchPhone: React.PropTypes.string,
    searchPhoneTabTwo: React.PropTypes.string,
    ownerId: PropTypes.string
  }

  constructor(props) {
    super(props);
    this.state = {
      showScript: false,
      searchActivePage: false,
      openSearch: false
    };
  }

  getTabInfo = (tabIndex) => {
    const { strings, loginUserRecord } = this.props;
    let tabName = '';
    let tabLabel = '';
    let start = this.props.unassignedStartIndex;
    let end = this.props.unassignedEndIndex;
    if (!__MANAGE__ && tabIndex === 1) {
      tabName = 'Assigned';
      tabLabel = strings.assignedLeads;
      start = this.props.assignedStartIndex;
      end = this.props.assignedEndIndex;
    } else if (!__MANAGE__ && tabIndex === 0) {
      tabName = 'Unassigned';
      tabLabel = strings.unAssignedLeads;
    } else if (!__MANAGE__ && tabIndex === 2) {
      tabName = 'Inspections';
      tabLabel = ((loginUserRecord.cica_positioncode === '14' && (loginUserRecord.cica_salesforce === '19' || loginUserRecord.cica_salesforce === '18')) || ((loginUserRecord.cica_positioncode === '16') && loginUserRecord.cica_salesforce === '02')) ? strings.teamInspections : strings.inspections;
      start = this.props.inspectedStartIndex;
      end = this.props.inspectedEndIndex;
    } else if (__MANAGE__ && tabIndex === 0) {
      console.log('this.props.tabActiveLeadsList==>', this.props.tabActiveLeadsList);
      tabName = 'Active';
      tabLabel = strings.priorityLeadsTab;
      start = 0;
      end = this.props.tabActiveLeadsList.length;
    } else if (__MANAGE__ && tabIndex === 2) {
      tabName = 'Closed';
      tabLabel = strings.closedLeads;
      start = 0;
      end = this.props.tabTwoList.length;
    } else if (__MANAGE__ && tabIndex === 1) {
      console.log('this.props.tabOneList==>', this.props.tabOneList);
      tabName = 'Assigned';
      tabLabel = strings.openLeadsTab;
      start = 0;
      end = this.props.tabOneList.length;
    }

    return {
      tabName,
      tabLabel,
      start,
      end
    };
  }

  filterList = (tabIndex, list) => {
    const { start, end } = this.getTabInfo(tabIndex);
    if (list.length <= start) {
      return list
        .slice(0, end - start);
    }
    return list
    .slice(start, end);
  };

  searchActivePage = () => {
    this.props.updateActivePage(true);
  };

  handleFixedTabChange = (index) => {
    this.props.updateActiveIndex(index);
  };

  togglePopupInspectionScript = () => {
    this.setState({
      showScript: !this.state.showScript
    });
  }

  recordCount = (tabIndex) => {
    switch (tabIndex) {
      case 0:
        return (__MANAGE__) ? this.props.tabActiveLeadsList.length : this.props.tabOneList.length;
      case 1:
        return (__MANAGE__) ? this.props.tabOneList.length : this.props.tabTwoList.length;
      case 2:
        if (__MANAGE__) {
          return this.props.tabTwoList.length;
        }
        return this.props.tabThreeList ? this.props.tabThreeList.length : 0;
      case 3:
        return this.props.tabThreeList ? this.props.tabThreeList.length : 0;
      default:
        return 0;
    }
  };

  isFiltered = (filterObj) => {
    const filterValues = Object.values(filterObj);
    return filterValues.some(value => value.length > 0);
  }

  fillOptions = (column) => {
    let columnData = '';
    columnData = util.filterDataCRMFieldMapper(column, this.props.strings);
    const mainList = this.props.leadsData.filter(obj => !obj.isSecondary);
    // let lastSellingAgentList = [];
    if (columnData === 'leadType') {
      debug('in the leadType');
      let warmLeadsFilter = '';
      if (__MANAGE__) {
        warmLeadsFilter = _.filter(mainList, { leadType: 'Warm', status: '1' });
      } else {
        warmLeadsFilter = _.filter(mainList, { leadType: 'Warm', status: 'Unassigned' });
      }
      warmLeadsCount = _.size(warmLeadsFilter);
    }
    let origlist = '';
    if (columnData === 'campaign') {
      origlist = _.orderBy(
        _.compact(
          _.uniq(
            _.flattenDeep(
              _.map(mainList, columnData)
            )
          )
        )
      );
    } else {
      origlist = _.orderBy(_.compact(_.uniq(_.map(mainList, columnData))));
      if (!__MANAGE__ && columnData === 'zip') {
        const newList = origlist.map(obj => obj.substr(0, 5));
        origlist = _.uniq(newList);
      }
      if (!__MANAGE__ && columnData === 'lineOneManager') {
        const { agentList } = this.props;
        const newList = [];
        agentList.forEach((element) => {
          if ((element.cica_positioncode == '10' && (element.cica_salesforce === '19' || element.cica_salesforce === '18')) || ((element.cica_positioncode == '60' || element.cica_positioncode == '33' || element.cica_positioncode == '70') && element.cica_salesforce === '02')) { // eslint-disable-line
            let managerCode = element.cica_agentcode;
            managerCode = managerCode.toUpperCase();
            let agentManagerName = element.fullname;
            agentManagerName = agentManagerName.split(' ');
            agentManagerName = `${agentManagerName[1]}, ${agentManagerName[0]} (${managerCode})`;
            newList.push(agentManagerName);
          }
        });
        origlist = _.sortBy(_.uniq(newList));
      }
      if (!__MANAGE__ && columnData === 'activeLastSellingAgentName') {
        const { agentList } = this.props;
        // lastSellingAgentList = this.getLastSellingAgentList();
        const newList = [];
        agentList.forEach((element) => {
          if ((element.cica_positioncode == '04' && (element.cica_salesforce === '19' || element.cica_salesforce === '18')) || ((element.cica_positioncode == '31' || element.cica_positioncode == '04' || element.cica_positioncode == '36') && element.cica_salesforce === '02')) { // eslint-disable-line
            let agentCode = element.cica_agentcode;
            agentCode = agentCode.toUpperCase();
            let agentName = element.fullname;
            agentName = agentName.split(' ');
            agentName = `${agentName[1]}, ${agentName[0]} (${agentCode})`;
            newList.push(agentName);
          }
        });
        origlist = _.sortBy(_.uniq(newList));
      }
    }
    let filteredList = '';

    if (columnData === 'campaign') {
      filteredList = _.orderBy(
        _.compact(
          _.uniq(
            _.flattenDeep(
              _.map(this.props.tabOneList, columnData)
            )
          )
        )
      );
    } else {
      filteredList = _.orderBy(_.compact(_.uniq(_.map(this.props.tabOneList, columnData))));
      if (!__MANAGE__ && columnData === 'zip') {
        const newList = filteredList.map(obj => obj.substr(0, 5));
        filteredList = _.uniq(newList);
      }
      if (!__MANAGE__ && (columnData === 'lineOneManager' || columnData === 'activeLastSellingAgentName')) {
        filteredList = _.sortBy(_.uniq(filteredList));
      }
    }
    let filteredIndex = 0;
    let shouldDisableField = false;
    return origlist.map((item) => {
      // debug('fillOptions - before list map - item', item);
      if (item !== filteredList[filteredIndex]) {
        shouldDisableField = true;
      } else {
        shouldDisableField = false;
        filteredIndex += 1;
      }
      return {
        clearableValue: false,
        disable: shouldDisableField,
        value: (item.indexOf('-') !== -1 || columnData === 'activeLastSellingAgentName' || columnData === 'lineOneManager' || item.typeof !== 'boolean') ? item : util.toTitleCase(item),// eslint-disable-line
        label: (columnData === 'leadType' && util.toTitleCase(item) === 'Warm' && this.props.activeIndex === 0) ?//eslint-disable-line
        `${util.toTitleCase(item)} (${warmLeadsCount})` : (columnData === 'activeLastSellingAgentName' || columnData === 'lineOneManager' || item.indexOf('-') !== -1) ? item : util.toTitleCase(item)
      };
    });
  }

  dataForFilters = ({ options }) => {
    if (!this.props.tabOneList.length) {
      return [];
    }

    return this.fillOptions(options);
  }

  renderTabTitle = (tabIndex) => {
    const { tabLabel } = this.getTabInfo(tabIndex);
    return (
      <span style={{ marginLeft: '-1em' }}>
        <span className={styles.tab1Value}>
          {this.recordCount(tabIndex)}
        </span> {tabLabel}
      </span>
    );
  }
  renderProgressBars = () => {
    const { progressBar, strings } = this.props;
    return Object.keys(progressBar).map((data) => {
      if (!progressBar[data].show) {
        return <div key={data} />;
      }
      if ((parseInt((progressBar[data].progress / progressBar[data].maxValue) * 100, 10)) > 100) {
        return (
          <div className={styles.progressView} key={data} >
            <span className={styles.progressBarTitle}>
              { `${progressBar[data].title} - 100% Completed` }
            </span>
            <ProgressBar
              mode={strings.determinate}
              max={progressBar[data].maxValue}
              value={progressBar[data].progress}
              theme={styles}
            />
          </div>
        );
      }
      return (
        <div className={styles.progressView} key={data} >
          <span className={styles.progressBarTitle}>
            {
              `${progressBar[data].title}  -  ${parseInt((progressBar[data].progress / progressBar[data].maxValue) * 100, 10)}% Completed`
            }
          </span>
          <ProgressBar
            mode="determinate"
            max={progressBar[data].maxValue}
            value={progressBar[data].progress}
            theme={styles}
          />
        </div>
      );
    });
  }

  renderTabs() {
    const navigationStyle = (__MANAGE__) ? styles.manageNavigation : styles.assignNavigation;
    const tabStyle = (__MANAGE__) ? styles.manageTab : styles.assignTab;
    if (!__MANAGE__) {
      return (
        <Tabs
          index={this.props.activeIndex}
          onChange={this.handleFixedTabChange}
          fixed
          className={styles.tabsComponent}
          theme={{ navigation: navigationStyle, tab: tabStyle, ...styles }}
        >
          <Tab
            label={this.renderTabTitle(0)}
            className={__MANAGE__ ? styles.manageTabUnassigned : styles.tabUnassigned}
            activeClassName={styles.activeTab}
          >
            <div className={styles.flWrapper}>
              <Filter
                flexValues={_.map(this.props.columnData, 'flexGrow')}
                updateFilterExpanded={this.props.updateFilterExpanded}
                filterExpanded={this.props.filterExpanded}
                filterData={this.props.filterData.filter(obj => obj.tab === 'both' || obj.tab === '0')}
                updateFilter={this.props.updateFilter}
                applyFilter={this.props.applyFilter}
                filterValues={this.props.filterValues[0]}
                isFiltered={this.isFiltered(this.props.filterValues[0])}
                clearFilter={this.props.clearFilter}
                activeIndex={this.props.activeIndex}
                list={this.props.tabOneList}
                agentList={this.props.agentList}
                leadsData={this.props.leadsData}
                updateNameSearchParameter={this.props.updateNameSearchParameter}
                updateStreetSearchParameter={this.props.updateStreetSearchParameter}
                strings={this.props.strings}
                currentLanguage={this.props.currentLanguage}
                updateSelectedRecords={this.props.updateSelectedRecords}
                loginUserRecord={this.props.loginUserRecord}
              />
              {
                this.props.dataIsLoading &&
                <div className={styles.loadingIndicatorContainer}>
                  <p>Loading Leads Data</ p>
                  <ProgressBar type="circular" mode="indeterminate" multicolor />
                  <Modal
                    isOpen={this.props.dataIsLoading}
                    className={styles.popupcontainer}
                    overlayClassName={styles.modalOverlayClassName}
                  />
                  {this.renderProgressBars()}
                </div>
              }
              { !this.props.dataIsLoading &&
                <VirtualTable
                  columnData={__MANAGE__ ?
                    this.props.columnData :
                    this.props.columnData.filter(
                      obj => obj.dataKey !== 'disposition' && obj.dataKey !== 'assignedTo' && obj.dataKey !== 'dateAssignedValue'
                    )
                  }
                  updateSelectedRecords={this.props.updateSelectedRecords}
                  selectedRecords={this.props.selectedRecords}
                  filterExpanded={this.props.filterExpanded}
                  list={this.props.tabOneList}
                  height={__TEST__ ? 763 : 0}
                  width={__TEST__ ? 763 : 0}
                  paginateList={this.filterList}
                  activeIndex={this.props.activeIndex}
                  applyFilter={this.props.applyFilter}
                  applySearchName={this.props.applySearchName}
                  applySearchStreet={this.props.applySearchStreet}
                  tabSearchList={this.props.tabOneSearchList}
                  priAndSecRecordMapping={this.props.priAndSecRecordMapping}
                  searchValueName={this.props.searchValueNameTabOne}
                  searchStreetAddress={this.props.searchStreetAddressTabOne}
                  updateNameSearchParameter={this.props.updateNameSearchParameter}
                  updateStreetSearchParameter={this.props.updateStreetSearchParameter}
                  strings={this.props.strings}
                  currentLanguage={this.props.currentLanguage}
                  searchActivePage={this.searchActivePage}
                />
              }
            </div>
          </Tab>
          <Tab
            label={this.renderTabTitle(1)}
            className={__MANAGE__ ? styles.manageTabAssigned : styles.tabAssigned}
            activeClassName={styles.activeTab}
          >
            <div className={styles.flWrapper}>
              <Filter
                flexValues={_.map(this.props.columnData, 'flexGrow')}
                updateFilterExpanded={this.props.updateFilterExpanded}
                filterExpanded={this.props.filterExpanded}
                filterData={this.props.filterData.filter(obj => obj.tab === 'both' || obj.tab === '1')}
                updateFilter={this.props.updateFilter}
                applyFilter={this.props.applyFilter}
                filterValues={this.props.filterValues[1]}
                isFiltered={this.isFiltered(this.props.filterValues[1])}
                clearFilter={this.props.clearFilter}
                list={this.props.tabTwoList}
                agentList={this.props.agentList}
                leadsData={this.props.leadsData}
                updateNameSearchParameter={this.props.updateNameSearchParameter}
                updateStreetSearchParameter={this.props.updateStreetSearchParameter}
                strings={this.props.strings}
                currentLanguage={this.props.currentLanguage}
                updateSelectedRecords={this.props.updateSelectedRecords}
                loginUserRecord={this.props.loginUserRecord}
              />
              <VirtualTable
                columnData={__MANAGE__ ?
                  this.props.columnData :
                  this.props.columnData.filter(
                    obj => obj.dataKey !== 'lastSelling' && obj.dataKey !== 'lastAssigned' && obj.dataKey !== 'assignedDate'
                  )
                }
                updateSelectedRecords={this.props.updateSelectedRecords}
                selectedRecords={this.props.selectedRecords}
                filterExpanded={this.props.filterExpanded}
                list={this.props.tabTwoList}
                height={__TEST__ ? 763 : 0}
                width={__TEST__ ? 763 : 0}
                paginateList={this.filterList}
                activeIndex={this.props.activeIndex}
                applySearchName={this.props.applySearchName}
                applySearchStreet={this.props.applySearchStreet}
                applyFilter={this.props.applyFilter}
                leadsData={this.props.leadsData}
                tabSearchList={this.props.tabTwoSearchList}
                priAndSecRecordMapping={this.props.priAndSecRecordMapping}
                searchValueName={this.props.searchValueNameTabTwo}
                searchStreetAddress={this.props.searchStreetAddressTabTwo}
                updateNameSearchParameter={this.props.updateNameSearchParameter}
                updateStreetSearchParameter={this.props.updateStreetSearchParameter}
                currentLanguage={this.props.currentLanguage}
                strings={this.props.strings}
                searchActivePage={this.searchActivePage}
              />
            </div>
          </Tab>
          <Tab
            label={this.renderTabTitle(2)}
            className={__MANAGE__ ? styles.manageTabAssigned : styles.tabInspection}
            activeClassName={styles.activeTab}
          >
            <div className={styles.tabContent}>
              <div className={styles.insFlWrapper}>
                <InspectionFilter
                  flexValues={_.map(this.props.inspectionsColumnData, 'flexGrow')}
                  updateInspectionFilterExpanded={this.props.updateInspectionFilterExpanded}
                  inspectionFilterExpanded={this.props.inspectionFilterExpanded}
                  inspectionFilterData={this.props.inspectionFilterData.filter(obj => obj.tab === 'single')}
                  filterValues={this.props.filterValues[2]}
                  list={this.props.tabThreeList}
                  clearFilter={this.props.clearFilter}
                  updateFilter={this.props.updateFilter}
                  applyFilter={this.props.applyFilter}
                  updateNameSearchParameter={this.props.updateNameSearchParameter}
                  strings={this.props.strings}
                  currentLanguage={this.props.currentLanguage}
                  updateWritingAgentParameter={this.props.updateWritingAgentParameter}
                  updateSelectedRecords={this.props.updateSelectedRecords}
                  activeIndex={this.props.activeIndex}
                />
                <VirtualTable
                  columnData={this.props.inspectionsColumnData.filter(
                      obj => obj.dataKey !== 'testKey') // test key added so that virtual table refreshes
                  }
                  list={this.props.tabThreeList}
                  height={__TEST__ ? 763 : 0}
                  width={__TEST__ ? 763 : 0}
                  paginateList={this.filterList}
                  activeIndex={this.props.activeIndex}
                  priAndSecRecordMapping={this.props.priAndSecRecordMapping}
                  searchValueName={this.props.searchValueNameTabThree}
                  updateNameSearchParameter={this.props.updateNameSearchParameter}
                  applySearchName={this.props.applySearchName}
                  applyFilterIndex={this.props.applyFilterIndex}
                  applySearchWritingAgent={this.props.applySearchWritingAgent}
                  tabSearchList={this.props.tabThreeSearchList}
                  searchWritingAgent={this.props.searchWritingAgentTabThree}
                  updateWritingAgentParameter={this.props.updateWritingAgentParameter}
                  updateSelectedRecords={this.props.updateSelectedRecords}
                  selectedRecords={this.props.selectedRecords}
                  clearFilterIndex={this.props.clearFilterIndex}
                  filterValues={this.props.filterValues[2]}
                  updateProgressBarValue={this.props.updateProgressBarValue}
                  strings={this.props.strings}
                  currentLanguage={this.props.currentLanguage}
                  searchActivePage={this.searchActivePage}
                  ownerId={this.props.ownerId}
                />
              </div>
            </div>
          </Tab>
        </Tabs>
      );
    }
    return (
      <Tabs
        index={this.props.activeIndex}
        onChange={this.handleFixedTabChange}
        fixed
        className={styles.tabsComponent}
        theme={{ navigation: navigationStyle, tab: tabStyle, ...styles }}
      >
        <Tab
          label={this.renderTabTitle(0)}
          className={__MANAGE__ ? styles.manageTabUnassigned : styles.tabUnassigned}
          activeClassName={styles.activeTab}
        >
          <div className={styles.flWrapper}>
            <Filter
              flexValues={_.map(this.props.columnData, 'flexGrow')}
              updateFilterExpanded={this.props.updateFilterExpanded}
              filterExpanded={this.props.filterExpanded}
              filterData={this.props.filterData.filter(obj => obj.tab === 'both' || obj.tab === '0')}
              updateFilter={this.props.updateFilter}
              applyFilter={this.props.applyFilter}
              filterValues={this.props.filterValues[0]}
              isFiltered={this.isFiltered(this.props.filterValues[0])}
              clearFilter={this.props.clearFilter}
              activeIndex={this.props.activeIndex}
              list={this.props.tabActiveLeadsList}
              leadsData={this.props.leadsData}
              updateNameSearchParameter={this.props.updateNameSearchParameter}
              updateStreetSearchParameter={this.props.updateStreetSearchParameter}
              updatePhoneParameter={this.props.updatePhoneParameter}
              strings={this.props.strings}
              currentLanguage={this.props.currentLanguage}
            />
            {
              this.props.dataIsLoading &&
              <div className={styles.loadingIndicatorContainer}>
                <p>Loading Leads Data</ p>
                <ProgressBar type="circular" mode="indeterminate" multicolor />
                <Modal
                  isOpen={this.props.dataIsLoading}
                  className={styles.popupcontainer}
                  overlayClassName={styles.modalOverlayClassName}
                />
                {this.renderProgressBars()}
              </div>
            }
            { !this.props.dataIsLoading &&
              <VirtualTable
                columnData={__MANAGE__ ?
                  this.props.columnData :
                  this.props.columnData.filter(
                    obj => obj.dataKey !== 'disposition' && obj.dataKey !== 'assignedTo'
                  )
                }
                updateSelectedRecords={this.props.updateSelectedRecords}
                selectedRecords={this.props.selectedRecords}
                list={this.props.tabActiveLeadsList}
                height={__TEST__ ? 763 : 0}
                width={__TEST__ ? 763 : 0}
                paginateList={this.filterList}
                activeIndex={this.props.activeIndex}
                applyFilter={this.props.applyFilter}
                applySearchName={this.props.applySearchName}
                applySearchStreet={this.props.applySearchStreet}
                tabSearchList={this.props.tabActiveSearchList}
                priAndSecRecordMapping={this.props.priAndSecRecordMapping}
                searchValueName={this.props.searchValueNamePriorityTab}
                searchStreetAddress={this.props.searchStreetAddressPriorityTab}
                updateNameSearchParameter={this.props.updateNameSearchParameter}
                updateStreetSearchParameter={this.props.updateStreetSearchParameter}
                updatePhoneParameter={this.props.updatePhoneParameter}
                strings={this.props.strings}
                applySearchPhone={this.props.applySearchPhone}
                searchPhone={this.props.searchPhonePriorityTab}

              />
            }
          </div>
        </Tab>
        <Tab
          label={this.renderTabTitle(1)}
          className={__MANAGE__ ? styles.manageTabOpenLeads : styles.tabUnassigned}
          activeClassName={styles.activeTab}
        >
          {<div className={styles.flWrapper}>
            <Filter
              flexValues={_.map(this.props.columnData, 'flexGrow')}
              updateFilterExpanded={this.props.updateFilterExpanded}
              filterExpanded={this.props.filterExpanded}
              filterData={this.props.filterData.filter(obj => obj.tab === 'both'
              || obj.tab === '1')}
              updateFilter={this.props.updateFilter}
              applyFilter={this.props.applyFilter}
              filterValues={this.props.filterValues[1]}
              isFiltered={this.isFiltered(this.props.filterValues[1])}
              clearFilter={this.props.clearFilter}
              activeIndex={this.props.activeIndex}
              list={this.props.tabOneList}
              leadsData={this.props.tabOneSearchedLeads}
              updateNameSearchParameter={this.props.updateNameSearchParameter}
              updateStreetSearchParameter={this.props.updateStreetSearchParameter}
              updatePhoneParameter={this.props.updatePhoneParameter}
              strings={this.props.strings}
              currentLanguage={this.props.currentLanguage}
            />
            {
              this.props.dataIsLoading &&
              <div className={styles.loadingIndicatorContainer}>
                <p>Loading Leads Data</ p>
                <ProgressBar type="circular" mode="indeterminate" multicolor />
                <Modal
                  isOpen={this.props.dataIsLoading}
                  className={styles.popupcontainer}
                  overlayClassName={styles.modalOverlayClassName}
                />
                {this.renderProgressBars()}
              </div>
            }
            { !this.props.dataIsLoading &&
              <VirtualTable
                columnData={__MANAGE__ ?
                  this.props.columnData :
                  this.props.columnData.filter(
                    obj => obj.dataKey !== 'disposition' && obj.dataKey !== 'assignedTo'
                  )
                }
                updateSelectedRecords={this.props.updateSelectedRecords}
                selectedRecords={this.props.selectedRecords}
                list={this.props.tabOneList}
                height={__TEST__ ? 763 : 0}
                width={__TEST__ ? 763 : 0}
                paginateList={this.filterList}
                activeIndex={this.props.activeIndex}
                applyFilter={this.props.applyFilter}
                applySearchName={this.props.applySearchName}
                applySearchStreet={this.props.applySearchStreet}
                tabSearchList={this.props.tabOneSearchList}
                priAndSecRecordMapping={this.props.priAndSecRecordMapping}
                searchValueName={this.props.searchValueNameTabOne}
                searchStreetAddress={this.props.searchStreetAddressTabOne}
                updateNameSearchParameter={this.props.updateNameSearchParameter}
                updateStreetSearchParameter={this.props.updateStreetSearchParameter}
                updatePhoneParameter={this.props.updatePhoneParameter}
                strings={this.props.strings}
                applySearchPhone={this.props.applySearchPhone}
                searchPhone={this.props.searchPhone}

              />
            }
          </div> }
        </Tab>
        <Tab
          label={this.renderTabTitle(2)}
          className={__MANAGE__ ? styles.manageTabAssigned : styles.tabAssigned}
          activeClassName={styles.activeTab}
        >
          <div className={styles.flWrapper}>
            <Filter
              flexValues={_.map(this.props.columnData, 'flexGrow')}
              updateFilterExpanded={this.props.updateFilterExpanded}
              filterExpanded={this.props.filterExpanded}
              filterData={this.props.filterData.filter(obj => obj.tab === 'both' || obj.tab === '2')}
              updateFilter={this.props.updateFilter}
              applyFilter={this.props.applyFilter}
              filterValues={this.props.filterValues[2]}
              isFiltered={this.isFiltered(this.props.filterValues[2])}
              clearFilter={this.props.clearFilter}
              list={this.props.tabTwoList}
              leadsData={this.props.leadsData}
              updateNameSearchParameter={this.props.updateNameSearchParameter}
              updateStreetSearchParameter={this.props.updateStreetSearchParameter}
              updatePhoneParameter={this.props.updatePhoneParameter}
              strings={this.props.strings}
              currentLanguage={this.props.currentLanguage}
            />
            <VirtualTable
              columnData={__MANAGE__ ?
                this.props.columnData :
                this.props.columnData.filter(
                  obj => obj.dataKey !== 'lastSelling' && obj.dataKey !== 'lastAssigned'
                )
              }
              updateSelectedRecords={this.props.updateSelectedRecords}
              selectedRecords={this.props.selectedRecords}
              list={this.props.tabTwoList}
              height={__TEST__ ? 763 : 0}
              width={__TEST__ ? 763 : 0}
              paginateList={this.filterList}
              activeIndex={this.props.activeIndex}
              applySearchName={this.props.applySearchName}
              applySearchStreet={this.props.applySearchStreet}
              applyFilter={this.props.applyFilter}
              leadsData={this.props.leadsData}
              tabSearchList={this.props.tabTwoSearchList}
              priAndSecRecordMapping={this.props.priAndSecRecordMapping}
              searchValueName={this.props.searchValueNameTabTwo}
              searchStreetAddress={this.props.searchStreetAddressTabTwo}
              updateNameSearchParameter={this.props.updateNameSearchParameter}
              updateStreetSearchParameter={this.props.updateStreetSearchParameter}
              updatePhoneParameter={this.props.updatePhoneParameter}
              strings={this.props.strings}
              applySearchPhone={this.props.applySearchPhone}
              searchPhone={this.props.searchPhoneTabTwo}
            />
          </div>
        </Tab>
      </Tabs>
    );
  }

  render() {
    const selectedRecordsCount = (this.props.activeIndex === 0) ?
      this.props.selectedRecords.filter(obj => obj.status === 'Unassigned' && !obj.isSecondary).length :
      this.props.selectedRecords.filter(obj => obj.status === 'Assigned' && !obj.isSecondary).length;
    return (
      <div className={styles.tabsContainer}>
        {this.renderTabs()}
        {(!__MANAGE__ && !this.props.filterExpanded) &&
          (this.props.activeIndex !== 2) &&
          <div className={styles.pagination}>
            <Pagination
              updateUnassignedStartEndIndex={this.props.updateUnassignedStartEndIndex}
              updateAssignedStartEndIndex={this.props.updateAssignedStartEndIndex}
              tabIndex={this.props.activeIndex}
              tabOneDropdownValue={
                (this.props.unassignedEndIndex - this.props.unassignedStartIndex).toString()
              }
              tabTwoDropdownValue={
                (this.props.assignedEndIndex - this.props.assignedStartIndex).toString()
              }
              selectedRecordsCount={selectedRecordsCount}
              recordCount={this.recordCount(this.props.activeIndex)}
              unassignedStartIndex={this.props.unassignedStartIndex}
              unassignedEndIndex={this.props.unassignedEndIndex}
              assignedStartIndex={this.props.assignedStartIndex}
              assignedEndIndex={this.props.assignedEndIndex}
              strings={this.props.strings}
              searchActivePage={this.props.activePage}
              updateActivePage={this.props.updateActivePage}
            />
          </div>}
        {/* {(__MANAGE__ && !this.props.filterExpanded) &&
          <div className={styles.pagination}>
            <Pagination
              updateUnassignedStartEndIndex={this.props.updateUnassignedStartEndIndex}
              updateAssignedStartEndIndex={this.props.updateAssignedStartEndIndex}
              tabIndex={this.props.activeIndex}
              tabOneDropdownValue={
                (this.props.unassignedEndIndex - this.props.unassignedStartIndex).toString()
              }
              tabTwoDropdownValue={
                (this.props.assignedEndIndex - this.props.assignedStartIndex).toString()
              }
              selectedRecordsCount={selectedRecordsCount}
              recordCount={this.recordCount(this.props.activeIndex)}
              unassignedStartIndex={this.props.unassignedStartIndex}
              unassignedEndIndex={this.props.unassignedEndIndex}
              assignedStartIndex={this.props.assignedStartIndex}
              assignedEndIndex={this.props.assignedEndIndex}
              strings={this.props.strings}
              searchActivePage={this.props.activePage}
              updateActivePage={this.props.updateActivePage}
            />
          </div>} */}
        {(!__MANAGE__ && !this.props.filterExpanded) &&
        (this.props.activeIndex === 2) &&
        <div className={styles.pagination}>
          <Pagination
            updateInspectedStartEndIndex={this.props.updateInspectedStartEndIndex}
            tabIndex={this.props.activeIndex}
            recordCount={this.recordCount(this.props.activeIndex)}
            tabThreeDropdownValue={
              (this.props.inspectedEndIndex - this.props.inspectedStartIndex).toString()
            }
            inspectedStartIndex={this.props.inspectedStartIndex}
            inspectedEndIndex={this.props.inspectedEndIndex}
            strings={this.props.strings}
            updateActivePage={this.props.updateActivePage}
          />
        </div>}
        {this.state.showScript &&
          <InspectionScriptPopup
            openPopup={this.state.showScript}
            togglePopupInspectionScript={this.togglePopupInspectionScript}
          />
        }
      </div>
    );
  }
}

const FixedTabsString = translate('FixedTabs')(FixedTabs);

export default (FixedTabsString);



// WEBPACK FOOTER //
// ./src/containers/FixedTabs/FixedTabs.js